import { makeStyles } from '@mui/styles'
import {
  CHARCOAL,
  GAINSBORO_BORDER,
  GOLD,
  GUNMETAL,
  MEDIUM_GRAY,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  RAVEN,
  VIVID_BLUE,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

const useStyles = makeStyles(() => ({
  spinner: {
    position: 'relative',
    minHeight: 300,
  },
  statusSelect: {
    width: '100%',

    '& > div': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  buttonsContainer: {
    position: 'fixed',
    width: '30%',
    bottom: 0,
    background: WHITE,
    borderTop: `1px solid ${GAINSBORO_BORDER}`,
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 -10px',
    padding: 10,
  },
  button: {
    padding: '0 10px',
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    lineHeight: '140%',
    fontWeight: 700,
    height: 40,
    border: 'none',
    borderRadius: 4,

    '&:hover': {
      opacity: 0.8,
    },
  },
  cancelButton: {
    backgroundColor: MEDIUM_GRAY,
    color: WHITE,

    '&:hover': {
      backgroundColor: MEDIUM_GRAY,
      border: 'none',
    },
  },
  saveButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    color: WHITE,

    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
      border: 'none',
    },
  },
  detailsRow: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      marginTop: 3,
    },
  },
  inputHead: {
    flexShrink: 0,
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0.2,
    width: '30%',
    marginRight: 10,
    color: CHARCOAL,
  },
  sectionInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: 37,
  },
  sectionText: {
    fontFamily: URBANIST,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '140%',
    letterSpacing: 0.2,
  },
  sectionTextBold: {
    fontWeight: 700,
  },
  sectionTextYellow: {
    color: GOLD,
  },
  table: {
    borderCollapse: 'collapse',
  },
  tableHead: {
    width: '100%',
    height: 'auto',
    border: 'none',
  },
  headerRow: {
    backgroundColor: 'RGBA(189, 189, 189, 0.2)',
    borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,

    '&:hover': {
      backgroundColor: 'RGBA(189, 189, 189, 0.2)',
      borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,
    },
  },
  headerCell: {
    color: 'RGBA(2, 2, 2, 0.2)',
    padding: 5,
    fontFamily: URBANIST,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '130%',
  },
  tableRow: {
    border: 'none',
    cursor: 'auto',
  },
  bodyCell: {
    padding: 5,
    borderBottom: `1px solid ${GAINSBORO_BORDER}`,
    color: GUNMETAL,
    fontFamily: URBANIST,
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '130%',
  },
  bodyCellId: {
    maxWidth: 120,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: VIVID_BLUE,
  },
  modalWrapper: {
    padding: '55px 25px 15px',
    overflowX: 'hidden',
  },
  modalTitle: {
    fontFamily: URBANIST,
    fontWeight: 600,
    fontSize: 30,
    lineHeight: '36px',
    textAlign: 'center',
    color: MIDNIGHT_EXPRESS,
  },
  modalDescription: {
    fontFamily: URBANIST,
    fontWeight: 275,
    fontSize: 16,
    lineHeight: '24px',
    textAlign: 'center',
    marginTop: '25px',
    color: RAVEN,
  },
  modalButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  modalButton: {
    width: '100%',
    height: '40px',
  },
  modalActionsWrapper: {
    width: '80%',
    margin: '20px auto',
  },
  offerAdjustmentSelect: {
    padding: 0,
  },
  routeScoreWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  routeScoreWrapperLeftAlign: {
    alignItems: 'flex-start',
    padding: '0px 8px',
  },
  selectDriverReliabilityPlaceholder: {
    left: 8,
  },
  rescheduledBodyCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
}))

export default useStyles
